import { render, staticRenderFns } from "./customerAnalysis.vue?vue&type=template&id=0b3ba06f&scoped=true&"
import script from "./customerAnalysis.vue?vue&type=script&lang=js&"
export * from "./customerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./customerAnalysis.vue?vue&type=style&index=0&id=0b3ba06f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ba06f",
  null
  
)

export default component.exports